var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{staticClass:"has-text-centered"},[_c('small',[_vm._v("現在時刻："+_vm._s(_vm.currentTime))])])
}
var staticRenderFns = []

export { render, staticRenderFns }